<template>
  <v-container fluid class="deposit-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Deposit</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Deposit</p>
                        <v-select
                          class="mb-4"
                          :items=deposittype
                          v-model="new_deposit.deposittype"
                          v-bind:error="errorindex == 0"
                          v-on:change="clearFields(); clearTransactions()"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the deposit type">
                        </v-select>
                        <v-menu
                          ref="menu_depositdate"
                          v-model="menu_depositdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_deposit.depositdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_deposit.depositdate"
                              label="Deposit Date"
                              v-bind="attrs"
                              v-bind:value="new_deposit.depositdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the deposit date"
                              persistent-hint
                              >
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_deposit.depositdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_depositdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_depositdate.save(new_deposit.depositdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        <v-select
                          v-if="type=='service'"
                          class="mb-4"
                          :items="locations.map(x => { return {text: x.locationname, value: x._id} })"
                          v-model="new_deposit.locationid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-select
                          v-if="type=='service'"
                          class="mb-4"
                          :items="departments.map(x => { return {text: x.departmentname, value: x._id} })"
                          v-model="new_deposit.departmentid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Department"
                          persistent-hint
                          single-line hint="Please choose the deparment">
                        </v-select>
                        <v-select
                          v-if="type=='rental'"
                          class="mb-4"
                          :items="[
                            {text: 'None', value: null},
                            ...properties.map(x => { return {text: x.propertyname, value: x._id} })
                          ]"
                          v-model="new_deposit.propertyid"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Property"
                          persistent-hint
                          single-line hint="Please choose the property">
                        </v-select>
                        <v-select
                          v-if="type=='rental'"
                          class="mb-4"
                          :items="[
                            {text: 'None', value: null},
                            ...regions.map(x => { return {text: x.regionname, value: x._id} })
                          ]"
                          v-model="new_deposit.regionid"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Region"
                          persistent-hint
                          single-line hint="Please choose the region">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="data_accounts"
                          v-model="new_deposit.accountid"
                          v-bind:error="errorindex == 6"
                          outlined
                          dense
                          placeholder="Deposit To Account"
                          persistent-hint
                          single-line hint="Enter the deposit to account">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="new_deposit.depositname"
                          v-bind:error="errorindex == 7"
                          outlined
                          dense
                          placeholder="Payer Name"
                          persistent-hint
                          single-line hint="Enter the payer name">
                        </v-text-field>   
                        <v-text-field
                          class="mb-4"
                          v-model="new_deposit.refnum"
                          outlined
                          dense
                          placeholder="Ref Num"
                          persistent-hint
                          single-line hint="Enter invoice or ref num">
                        </v-text-field>
                        <v-textarea
                          v-model="new_deposit.depositnote"
                          outlined
                          rows=1
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                          v-model="new_deposit.primaryCurrency"
                          v-bind:error="errorindex == 11"
                          outlined
                          dense
                          placeholder="Primary Currency"
                          persistent-hint
                          single-line hint="Please choose the primary currency">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                          v-model="new_deposit.secondaryCurrency"
                          v-bind:error="errorindex == 12"
                          v-bind:value="primaryCurrency"
                          outlined
                          dense
                          placeholder="Secondary Currency"
                          persistent-hint
                          single-line hint="Please choose the secondary currency">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="new_deposit.currencyRate"
                          v-bind:error="errorindex == 13"
                          :v-bind:value="1"
                          outlined
                          dense
                          placeholder="Rate"
                          persistent-hint
                          single-line hint="Enter the currency rate">
                        </v-text-field>

                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/deposit/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkDeposit">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row>
                    <v-col md="10">
                      <p class="text-h5">Items</p>
                    </v-col>
                    <v-col md="2" align="right">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="isAddTransaction=true">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-data-table
                          :headers="itemHeaders2"
                          :items="transactions"
                          :items-per-page="500"
                          :footer-props="footer"
                          class="elevation-0"
                        >
                          <template v-slot:item.accountid="{ item }">
                            {{ accounts.length>0 ? accounts.find(account=>account._id == item.accountid)['accountname'] : '' }}
                          </template>
                          <template v-slot:item.transdate="{ item }">
                            {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                          </template>
                          <template v-slot:item.actions="{ item }">
                            <v-btn icon color="primary" @click="editTransactionDialog(item)">
                              <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="deleteTransaction(item)">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="1==0"
                          class="button-shadow"
                          color="primary"
                          @click="step = 3">
                          Next
                        </v-btn>
                        <v-btn
                          v-else
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertDeposit()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses
                    v-model="accountsubclass"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="new_transaction.accountid"
                    v-bind:error="errorindex == 11"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="new_transaction.itemdesc"
                    v-bind:error="errorindex == 12"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="new_transaction.itemamount"
                    v-bind:error="errorindex == 13"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="addTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_classes
                    v-model="accountclass2"
                    outlined
                    dense
                    placeholder="Class"
                    persistent-hint
                    single-line hint="Please choose the class">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items=data_subclasses2
                    v-model="accountsubclass2"
                    outlined
                    dense
                    placeholder="Subclass"
                    persistent-hint
                    single-line hint="Please choose the subclass">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    class="mb-4"
                    :items="accounts.filter(account=>account.accountsubclass==accountsubclass2).map(x => {
                        return {text: x.accountname, value: x._id};
                    })"
                    v-model="edit_transaction.accountid"
                    outlined
                    dense
                    placeholder="Account"
                    persistent-hint
                    single-line hint="Account">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Desc"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import { sortDataAsc } from '../../../util/tools';
import router from '@/Routes';

export default {
  data () {
    return {
      itemHeaders2: [
        { text: 'Account', value: 'accountid', width: '35%'},
        { text: 'Description', value: 'itemdesc'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      classes: ['Cost of Good Sold', 'Administrative Expense', 'Operating Expense', 'Marketing Expense', 'Tax & Financing Expense', 'Factory & Production Expense', 'Debt & Loan', 'Overhead'],
      

      step: 1,
      new_deposit: {},
      new_transaction: {},
      edit_transaction: {},
      transactions: [],
      searches: [],
      deposittype: ['Deposit', 'Bank Transfer'],
      depositpayterms: ['Due on Receipt', 'Credit 15 Days', 'Credit 30 Days'],

      searchvendor: {},
      type: null,
      isSearchVendor: false,
      isRental: false,
      isAddTransaction: false,
      isEditTransaction: false,
      menu_depositdate: false,
      menu_depositduedate: false,
      menu_transdate: false,
      menu_transdate_edit: false,

      accountclass: null,
      accountclass2: null,
      accountsubclass: null,
      accountsubclass2: null,


      error: undefined,
      haserror: false,
      errorindex: undefined,
      isDualCurrency: false,
      primaryCurrency: null,
      secondaryCurrency: null,
      currencyRate: null,
      isTaxable: false,
      taxRate: null,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Deposit', ['deposits', 'isReceiving']),
    ...mapState('Department', ['departments']),
    ...mapState('Location', ['locations']),
    ...mapState('SystemSetting', ['settings']),
    ...mapState('Property', ['properties']),
    ...mapState('Region', ['regions']),
    ...mapState('User', ['users']),
    ...mapState('Vendor', ['vendors']),
    data_accounts(){
      let filter = this.accounts.filter(account=>account.accountsubclass=='Bank').map(x => {return {text: x.accountname, value: x._id}});
      return filter;
    },
    data_classes(){
      let object = Object.groupBy(this.accounts, item => {
        return item.accountclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
    data_subclasses2(){
      let filter = this.accounts.filter(account=>account.accountclass==this.accountclass2);
      let object = Object.groupBy(filter, item => {
        return item.accountsubclass;
      });
      let result = Object.keys(object);
      return result;
    },
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Deposit', ['getDepositsRequest', 'insertDepositRequest']),
    ...mapActions('Department', ['getDepartmentsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('Property', ['getPropertiesRequest']),
    ...mapActions('Region', ['getRegionsRequest']),
    ...mapActions('Search', ['searchVendorRequest']),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    ...mapActions('User', ['getUsersRequest']),
    ...mapActions('Vendor', ['getVendorsRequest']),
    checkDeposit(){
      if(!this.new_deposit.deposittype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_deposit.depositdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(this.type=='service' && !this.new_deposit.locationid){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(this.type=='service' && !this.new_deposit.departmentid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      // if(this.type=='rental' && !this.new_deposit.propertyid){
      //   this.haserrors = true;
      //   this.errorindex = 4;
      //   return false;
      // }
      // if(this.type=='rental' && !this.new_deposit.regionid){
      //   this.haserrors = true;
      //   this.errorindex = 5;
      //   return false;
      // }
      if(!this.new_deposit.accountid){
        this.haserrors = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.new_deposit.depositname){
        this.haserrors = true;
        this.errorindex = 7;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    addTransaction(){
      if(!this.checkTransaction()) return;
      let trans = Object.assign({}, this.new_transaction, {id: Math.floor(Math.random() * Math.pow(10, 10))});
      this.transactions.push(trans);
      this.clearFields();
      this.isAddTransaction = false;
    },
    clearFields(){
      this.new_transaction = {};
    },
    clearTransactions(){
      this.transactions = [];
    },
    async insertDeposit() {
      if(this.transactions==null || this.transactions.length==0) return;
      let payload = {deposit: this.new_deposit, transactions: this.transactions};
      await this.insertDepositRequest(payload);
      router.push('/deposit/list');
    },
    deleteTransaction(item){
      let index = this.transactions.findIndex((trans) => trans.id == item.id);      
      if(index!=-1) this.transactions.splice(index,1);
    },
    editTransactionDialog(item){
      let account = this.accounts.find(account=>account._id == item.accountid);
      this.accountclass2 = account.accountclass;
      this.accountsubclass2 = account.accountsubclass;
      this.edit_transaction = Object.assign({}, item);
      this.isEditTransaction = true;
    },
    editTransaction(){
      this.isEditTransaction = false;
      let index = this.transactions.findIndex((trans) => trans.id == this.edit_transaction.id);
      let trans = Object.assign({}, this.edit_transaction);
      this.transactions.splice(index, 1, trans);
      this.edit_transaction = {};
    },
    searchVendorDialog(){
      this.searchvendor = {};
      this.isSearchVendor = true;
    },
    selectVendor(item){
      this.new_deposit.depositname = item.vendorname;
      this.new_deposit.depositaddress = item.vendoraddress;
      this.new_deposit.depositphone = item.vendorphone;
      this.new_deposit.depositmobile = item.vendormobile;
      this.new_deposit.vendorid = item._id;
      this.isSearchVendor = false;
    },
    async searchVendor(){
      let results = await this.searchVendorRequest(this.searchvendor);
      this.searches = results;
    }
  },

  async created () {
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.departments.length==0) await this.getDepartmentsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.properties.length==0) await this.getPropertiesRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();
    sortDataAsc(this.departments, 'departmentname');
    sortDataAsc(this.locations, 'locationame');

    let currency = await this.getSetting({code: 'CurrencySettings', name: 'PrimaryCurrency'}, );
    let isTaxable = await this.getSetting({code: 'TaxSettings', name: 'isTaxEnabled'}, );
    this.new_deposit = Object.assign({}, {primaryCurrency: currency, secondaryCurrency: currency, currencyRate: 1, isTaxable: isTaxable});

    this.isRental = await this.getSetting({code: 'CompanySettings', name: 'isRental'}, );
    this.isRental==true ? this.type='rental' : this.type='service';
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
